import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NewsListComponent} from '@shared/modules/shared-news-list/components/news-list/news-list.component';
import {NewsListItemComponent} from '@shared/modules/shared-news-list/components/news-list-item/news-list-item.component';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {LibAdsModule} from '@lib-modules/ads/lib-ads.module';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {LibImageModule} from '@components/image/lib-image.module';
import {MatChipsModule} from '@angular/material/chips';
import {LibChipsModule} from '@lib-modules/chips/lib-chips.module';
import {LibNewsModule} from '@components/news/lib-news.module';

@NgModule({
  declarations: [
    NewsListComponent,
    NewsListItemComponent,
  ],
  imports: [
    CommonModule,
    SharedNewsModule,
    LibAdsModule,
    LibImageModule,
    MatChipsModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    LibChipsModule,
    LibNewsModule,
  ],
  exports: [
    NewsListComponent,
    NewsListItemComponent
  ]
})
export class SharedNewsListModule { }
